import {TypedValue} from 'notebook/tables/TableConstants';
import {getStorableInfosFromTypedValue} from 'notebook/tables/typed-values/DataTypes';

export default function extractStorableId(storableTypedValue: TypedValue | null): string | null {
  const storableInfos = getStorableInfosFromTypedValue(storableTypedValue);
  if (storableInfos.length === 0) {
    return null;
  } else if (storableInfos.length > 1) {
    return null;
  }

  const [storableInfo] = storableInfos;
  return storableInfo.id;
}
